// Init productCustomise object
let productCustomise = {};
// Init function for registering event listeners
let registerCustomiseEventListeners;
// Init function for CTA state
let ctaState;



// All customisation JS wrapped in conditional to only apply to available products
if(addToBagButton) {


  const urlParams = new URLSearchParams(window.location.search);
  let urlVariantId = urlParams.get('variant') ? urlParams.get('variant') : null;
  let urlBespokeSize = urlParams.get('bespoke-size') ? urlParams.get('bespoke-size') : null;
  const customiseSections = document.querySelectorAll('.customise-section');
  const firstOrSelectedVariantId = productTop.getAttribute('data-selected-variant-id');
  const defaultProductAvailability = productTop.getAttribute('data-product-availability') ? productTop.getAttribute('data-product-availability') : null;
  //const shippingTime = document.getElementById('shipping-time');
  const customiseInfo = productTop.querySelector('.customise-info');
  // const outOfStockMessage = productTop.querySelector('.customise-message.out-of-stock');
  let defaultShippingTime = productTop.getAttribute('data-product-shipping-time') ? productTop.getAttribute('data-product-shipping-time') : null;
  // if(outOfStockMessage && defaultProductAvailability == 'out-of-stock') {
  //   defaultShippingTime = outOfStockMessage.innerText.trim();
  // }
  const productCTA = document.getElementById('product-cta');
  let multiOptionVariants = productTop.getAttribute('data-multi-option-variants') ? true : false;
  let multiOptionVariantsSelection = {};


  // Build productCustomise object default selection
  productCustomise = {
    sections: [],
    selection: {
      variant_id: firstOrSelectedVariantId, // Init with liquid's "selected_or_first_available_variant"
      shipping_time: defaultShippingTime, // Init with out-of-stock message OR product's default shipping time
      availability_status: defaultProductAvailability, // Init with product's default availability status
      props: {}
    }
  };


  // Apply state to CTA button
  ctaState = () => {
    // CTA button state
    if (productCustomise.sections.length) {
      // Check for any incomplete required sections
      for (let i = 0; i < productCustomise.sections.length; i++) {
        let section = productCustomise.sections[i];
        if (section.required == true && section.complete == false) {
          // addToBagButton.classList.add('faded');
          break;
        }
        // addToBagButton.classList.remove('faded');
      }
    } else {
      collectInStoreNoticeDisplay(productCustomise.selection.availability_status); // Check if eligible for Collect in Store
      // addToBagButton.classList.remove('faded');
    }
  }



  // Build productCustomise object sections
  const buildCustomiseObjectSection = (customiseSection, i) => {
    productCustomise.sections[i] = {};
    // DOM element
    productCustomise.sections[i].dom_element = customiseSection;
    // Customisation type
    productCustomise.sections[i].customisation_type = customiseSection.getAttribute('data-customise-type');
    // UI type
    productCustomise.sections[i].ui_type = '';
    if (customiseSection.querySelector('.customise-options-block .pills')) {
      productCustomise.sections[i].ui_type = 'pills';
    } else if (customiseSection.querySelector('.customise-options-block .customise-dropdown-btn')) {
      productCustomise.sections[i].ui_type = 'dropdown';
    }
    // Add-on
    productCustomise.sections[i].add_on = customiseSection.classList.contains('add-on') ? true : false;
    productCustomise.sections[i].add_on_variant_id = null;
    // Multi-option variants
    productCustomise.sections[i].multi_option_variants = customiseSection.getAttribute('data-multi-option-variant-section') == 'true' ? true : false;
    // Options
    productCustomise.sections[i].options = [];
    const getOptionData = (optionElements)  => {
      optionElements.forEach(function(option, j){
        productCustomise.sections[i].options[j] = {
          variant_title: option.innerText.replace('\n', ' '),
          variant_id: option.getAttribute('data-variant-id'),
          variant_availability_status: option.getAttribute('data-availability'),
          variant_shipping_time: option.getAttribute('data-shipping-time'),
          option_dom_element: option
        };
      });
    }
    if (customiseSection.querySelector('.customise-options-block .pill')) {
      let optionElements = customiseSection.querySelectorAll('.customise-options-block .pill');
      getOptionData(optionElements);
    }
    else if (customiseSection.querySelector('.customise-options-block .dropdown-option')) {
      let optionElements = customiseSection.querySelectorAll('.customise-options-block .dropdown-option');
      getOptionData(optionElements);
    }
    // Default HTML
    productCustomise.sections[i].default_innerHTML = customiseSection.innerHTML;
    // Required status
    productCustomise.sections[i].required = false;
    if (customiseSection.getAttribute('data-required') == 'true') {
      productCustomise.sections[i].required = true;
    }
    // Complete status
    productCustomise.sections[i].complete = false;
    if (customiseSection.querySelector('.customise-options-block .pill.active')) {
      productCustomise.sections[i].complete = true;
    }
    // Customise property (for cart)
    productCustomise.sections[i].customise_prop = customiseSection.getAttribute('data-customise-prop');
  }




  // Get index of closest customise section from element
  const getCustomiseSectionIndex = (el) => {
    let thisCustomiseSection = el.closest('.customise-section');
    let thisCustomiseSectionIndex = Array.from(customiseSections).indexOf(thisCustomiseSection);
    return thisCustomiseSectionIndex;
  }




  // Push variant ID of selected to URL parameter
  const changeUrlVariantId = (variantId) => {
    urlParams.set('variant', variantId);
    let updatedParams = urlParams.toString();
    window.history.replaceState({}, '', `${window.location.pathname}?${updatedParams}`);
  }




  // Get inner text excluding text of chld elements
  const getDirectInnerTextOnly = (el) => {
    let cloneElement = el.cloneNode(true);
    let children = Array.from(cloneElement.children);
    if(children) {
      children.forEach((child) => {
        child.remove();
      });
    }
    return cloneElement.innerText.trim();
  }




  // Update the shipping time of the product based on selection
  const updateShippingTime = (selection) => {
    // If out-of-stock message and selection is out-of stock. use message
    // if(outOfStockMessage && selection.getAttribute('data-availability') == 'out-of-stock') {
    //   // Update shipping time prop
    //   productCustomise.selection.shipping_time = outOfStockMessage.innerText.trim();
    // }
    // Else use selection shipping time
    //else {
      if(selection.getAttribute('data-shipping-time')) {
        let selectionShippingTime = selection.getAttribute('data-shipping-time');
        // Only apply if the new shipping time is different
        if(selectionShippingTime !== productCustomise.selection.shipping_time) {
          /*
          if(customiseInfo){
            // Create new shipping time and append
            let newShippingTimeEl = document.createElement('span');
            newShippingTimeEl.classList.add('new')
            newShippingTimeEl.innerText = selectionShippingTime;
            shippingTime.append(newShippingTimeEl);
            shippingTime.classList.add('update');
            // Reset shipping time element after transition
            setTimeout(() => {
              shippingTime.innerHTML = selectionShippingTime;
              shippingTime.classList.remove('update');
            }, 400); // Timeout delay = CSS transition time+delay
          }
          */
          // Update shipping time prop
          productCustomise.selection.shipping_time = selectionShippingTime;
        }
        // Highlight extended shipping legend
        // if(customiseInfo){
        //   let customiseLegend = customiseInfo.querySelector('.customise-legend');
        //   if(customiseLegend && customiseLegend.classList.contains('extended')){
        //     if(selection.getAttribute('data-availability') == 'out-of-stock') {
        //       customiseLegend.classList.add('active');
        //     } else {
        //       customiseLegend.classList.remove('active');
        //     }
        //   }
        // }
        if(customiseInfo){
          let customiseAvailabilityInfoBtn = customiseInfo.querySelector('.customise-availability-info-btn');
          if(customiseAvailabilityInfoBtn){
            if(selection.getAttribute('data-availability') == 'out-of-stock') {
              customiseAvailabilityInfoBtn.classList.add('active');
            } else {
              customiseAvailabilityInfoBtn.classList.remove('active');
            }
          }
        }
      }
    //}
  }



  // Show/hide chat button
  // const chatButtonDisplay = (display) => {
  //   if (window.GorgiasChat) { // check Gorgias chat widget is on page
  //     if(display == 'show') {
  //       GorgiasChat.hideChat(false);
  //     } else if(display == 'hide') {
  //       GorgiasChat.hideChat(true);
  //     }
  //   }
  // }

  // // Show/hide product overview video
  // const productOverviewDisplay = (display) => {
  //   if(document.getElementById('product-overview-overlay')) {
  //     if(display == 'show') {
  //       document.getElementById('product-overview-overlay').classList.remove('loading');
  //     } else if(display == 'hide') {
  //       document.getElementById('product-overview-overlay').classList.add('loading');
  //     }
  //   }
  // }




  // Update product title and price upon selection of price-dependent variant
  const updateProductTitleAndPrice = (selection) => {
    // Update product title with variant
    // const productTitleSpan = productTop.querySelector('h1 span');
    // if (productTitleSpan.innerText.indexOf(' - ') >=0) {
    //   let titleVariantSbstr = productTitleSpan.innerText.split(' - ')[1];
    //   productTitleSpan.innerText = productTitleSpan.innerText.replace(titleVariantSbstr, getDirectInnerTextOnly(selection));
    // }
    // Update product price
    const productPrice = document.getElementById('product-price');
    const productCompareAtPrice = document.getElementById('product-compare-at-price');
    const priceBlock = document.getElementById('price-and-metal');
    if (productPrice.innerText !== selection.querySelector('.price').innerText) {
      productPrice.innerText = selection.querySelector('.price').innerText;
    }
    if (selection.getAttribute('data-compare-at-price')) {
      // Set compare-at-price and show it
      productCompareAtPrice.innerText = selection.getAttribute('data-compare-at-price');
      priceBlock.classList.add('has-compare-at-price');
    } else {
      // Hide compare-at-price
      priceBlock.classList.remove('has-compare-at-price');
    }
  } // updateProductTitleAndPrice()



  // Check if eligible for Collect in Store
  const collectInStoreNoticeDisplay = (selectionAvailability) => {
    const collectInStoreNotice = document.getElementById('collect-in-store-notice');
    if(collectInStoreNotice) {
      if(selectionAvailability == 'available') {
        collectInStoreNotice.style.display = 'block';
        setTimeout(() => { collectInStoreNotice.classList.add('shine'); },200);
      } else {
        collectInStoreNotice.style.display = 'none';
        collectInStoreNotice.classList.remove('shine');
      }
    }
  }




  // Multi-option variant (MOV) check and apply
  const multiOptionVariantsApply = (selection) => {
    if (multiOptionVariants) {

      // Update MOV disc pill prices
      let customiseDiscsSection = document.querySelector('.customise-discs');
      let selectionSection = selection.closest('.customise-section');
      if(customiseDiscsSection && !selectionSection.classList.contains('customise-discs')) {
        if(selection.getAttribute('data-variant-option-value')) {
          let selectionOptionValue = selection.getAttribute('data-variant-option-value');
          customiseDiscsSection.querySelectorAll('.pill').forEach(function(pill){
            let discOptionValue = pill.getAttribute('data-variant-option-value');
            for (let i = 0; i < productJSON.variants.length; i++){
              let variant = productJSON.variants[i];
              if(variant.option_values.includes(selectionOptionValue) && variant.option_values.includes(discOptionValue)) {
                pill.querySelector('.price').innerText = variant.price_formatted;
                break;
              }
            }
          });
        }
      }

      // Update MOV selection object
      let selectionOptionName = selection.getAttribute('data-variant-option-name');
      let selectionOptionValue = selection.getAttribute('data-variant-option-value');
      multiOptionVariantsSelection[selectionOptionName] = selectionOptionValue;
      // Check for any incomplete MOV sections
      let allSectionsComplete = true;
      for (let i = 0; i < productCustomise.sections.length; i++) {
        if (productCustomise.sections[i].multi_option_variants == true && productCustomise.sections[i].complete == false) {
          allSectionsComplete = false;
          break;
        }
      }
      // Apply MOV selection
      if(allSectionsComplete == true) {
        // Convert selection object to array of values
        let selectionValues = [];
        Object.values(multiOptionVariantsSelection).forEach((value) => {
          selectionValues.push(value);
        });
        // Cross check multiOptionVariantsSelection with product JSON and determine variant ID
        for (let i = 0; i < productJSON.variants.length; i++){
          let variant = productJSON.variants[i];
          // If all selectionValues are in variantOptionValues array, this is the matching variant
          // Ref: https://stackoverflow.com/questions/53606337/check-if-array-contains-all-elements-of-another-array
          if(selectionValues.every(v => variant.option_values.includes(v)) == true) {
            productCustomise.selection.variant_id = variant.id; // Update selection variant ID
            changeUrlVariantId(variant.id); // Update URL variant ID
            // Update product price
            const productPrice = document.getElementById('product-price');
            const productCompareAtPrice = document.getElementById('product-compare-at-price');
            const priceBlock = document.getElementById('price-and-metal');
            productPrice.innerText = variant.price_formatted;
            if (variant.compare_at_price !== "") { // Set compare-at-price and show it
              productCompareAtPrice.innerText = variant.compare_at_price_formatted;
              priceBlock.classList.add('has-compare-at-price');
            } else { // Hide compare-at-price
              priceBlock.classList.remove('has-compare-at-price');
            }
            // Update availability and shipping
            productCustomise.selection.availability_status = variant.availability_status;
            productCustomise.selection.shipping_time = variant.shipping_time;
            // Check if eligible for Collect in Store
            collectInStoreNoticeDisplay(variant.availability_status);
            if(customiseInfo){
              let customiseAvailabilityInfoBtn = customiseInfo.querySelector('.customise-availability-info-btn');
              if(variant.availability_status == 'out-of-stock') {
                customiseAvailabilityInfoBtn.classList.add('active');
              } else {
                customiseAvailabilityInfoBtn.classList.remove('active');
              }
            }
            break;
          }
        }
      }
    }
  } // multiOptionVariantsApply()
  






  // Register event listeners
  registerCustomiseEventListeners = (customiseSection) => {

    // Close dropdowns with click away
    const closeDropdownClickAway = (e) => {
      // Prevent action if dropdown modal is clicked or availability overlay is clicked
      //if (!e.target.closest('.dropdown-panel') && !e.target.closest('.customise-availability-overlay')){
      if (!e.target.closest('.dropdown-panel')){
        const customiseDropdowns = document.querySelectorAll('.customise-dropdown');
        customiseDropdowns.forEach(function(dropdown){
          dropdown.classList.remove('active');
          document.removeEventListener('click', closeDropdownClickAway, true); // Disable event listener after close
        });
        handleFixedElements('show');
      }
    }

    // Open dropdowns/overlays
    if (customiseSection.querySelector('.customise-dropdown-btn')) {
      let dropdownBtn = customiseSection.querySelector('.customise-dropdown-btn');
      dropdownBtn.addEventListener('click', e => {
        // Dropdown
        if (customiseSection.querySelector('.customise-dropdown')) {
          let dropdown = customiseSection.querySelector('.customise-dropdown');
          dropdown.classList.add('active');
          document.addEventListener('click', closeDropdownClickAway, true); // Enable event listener
        // Overlay
        } else if (customiseSection.querySelector('.customise-overlay')) {
          let overlay = customiseSection.querySelector('.customise-overlay');
          overlay.classList.add('active');
        }
        handleFixedElements('hide');
      });
    }

    // Close dropdowns with click X
    if (customiseSection.querySelector('.customise-dropdown')) {
      let dropdown = customiseSection.querySelector('.customise-dropdown');
      let dropdownCloseButton = dropdown.querySelector('.close-btn');
      dropdownCloseButton.addEventListener('click', e => {
        dropdown.classList.remove('active');
        handleFixedElements('show');
        document.removeEventListener('click', closeDropdownClickAway, true); // Disable event listener after close
      });
    }

    // Open customise availability info
    document.querySelectorAll('.customise-availability-info-btn').forEach(function(button){
      button.addEventListener('click', e => {
        let overlay = document.getElementById(button.getAttribute('data-open-overlay-id'));
        overlay.classList.add('active');
        handleFixedElements('hide');
      });
    });


    // Pills (Ring-size, chain-length, etc.)
    if (customiseSection.querySelector('.pill')) {

      customiseSection.querySelectorAll('.pill').forEach(function(pill){
        // Click pill
        pill.addEventListener('click', e => {
          let thisPillGroup = pill.closest('.pills');
          let thisOptionsBlock = pill.closest('.customise-options-block');
          let variantId = pill.getAttribute('data-variant-id');
          let propKey = customiseSection.getAttribute('data-customise-prop');
          // Change button state
          thisPillGroup.querySelectorAll('.pill').forEach((p) => p.classList.remove('active'));
          // Check availability of selected
          if (pill.getAttribute('data-availability') !== 'discontinued') {
            pill.classList.add('active');
            customiseSection.classList.add('complete');
            productCustomise.sections[getCustomiseSectionIndex(pill)].complete = true;
            thisOptionsBlock.querySelector('.customise-prompt').style.display = 'none';
            if(pill.querySelector('.price')) {
              // Update props, excluding price text
              // productCustomise.selection.props[propKey] = getDirectInnerTextOnly(pill);
              // Update product title and price
              updateProductTitleAndPrice(pill);
            } else {
              // Update props
              // productCustomise.selection.props[propKey] = pill.innerText.replace('\n', ' / ');
            }
            if (multiOptionVariants) {
              multiOptionVariantsApply(pill);
            } else {
              // Allow Birthstone to override ring-size (in the case where product has ring-size and birthstone selection)
              if(!productCustomise.selection.props.Birthstone){
                productCustomise.selection.variant_id = variantId;
                productCustomise.selection.availability_status = pill.getAttribute('data-availability');
                // Update URL with variiant ID of selected
                changeUrlVariantId(variantId);
                // Shipping time
                updateShippingTime(pill);
                // Check if eligible for Collect in Store
                collectInStoreNoticeDisplay(pill.getAttribute('data-availability'));
              }
            }
            // Update CTA
            ctaState();
          }
        });
      });

    } // Pills

    // Ring Size dropdown
    if (customiseSection.classList.contains('customise-ring-size')) {

      const customiseRingSizeSection = document.querySelector('.customise-ring-size');
      const ringSizeDropdownBtn = customiseRingSizeSection.querySelector('.customise-dropdown-btn');
      const ringSizeDropdown = customiseRingSizeSection.querySelector('.customise-dropdown');
      const ringSizeOptions = ringSizeDropdown.querySelectorAll('.dropdown-panel .dropdown-option');
      let propKey = customiseSection.getAttribute('data-customise-prop');

      // Select item
      ringSizeOptions.forEach(function(ringSizeOption){
        ringSizeOption.addEventListener('click', e => {
          let availabilityStatus = ringSizeOption.getAttribute('data-availability');
          if (availabilityStatus !== 'discontinued') {
            // Close panel
            ringSizeDropdown.classList.remove('active');
            handleFixedElements('show');
            // Update dropdown button
            let selectionTitle = ringSizeOption.innerText.replace('\n', ' / ');
            let variantId = ringSizeOption.getAttribute('data-variant-id');
            ringSizeDropdownBtn.innerHTML = `<span>${selectionTitle}</span>`;
            // Mark section complete
            customiseRingSizeSection.classList.add('complete');
            productCustomise.sections[getCustomiseSectionIndex(ringSizeOption)].complete = true;
            customiseRingSizeSection.querySelector('.customise-prompt').style.display = 'none';
            productCustomise.selection.variant_id = variantId;
            productCustomise.selection.availability_status = availabilityStatus;
            // Update shipping time
            setTimeout(() => {
              updateShippingTime(ringSizeOption);
            },200); // Timeout delay for dropdown panel closing
            // Check if eligible for Collect in Store
            collectInStoreNoticeDisplay(availabilityStatus);
            // Update props
            // productCustomise.selection.props[propKey] = selectionTitle.replace('\n', ' / ');
            // if(availabilityStatus.includes('bespoke') || availabilityStatus.includes('out-of-stock')) {
            if(availabilityStatus.includes('bespoke')) {
              productCustomise.selection.props[propKey] = `${selectionTitle.replace('\n', ' / ')}  - MADE TO ORDER`;
            } else {
              delete productCustomise.selection.props[propKey];
            }
            // Push variant ID of selected to URL parameter
            changeUrlVariantId(variantId);
            // If bespoke size, push as URL parameter, else remove bespoke size parameter
            if(availabilityStatus.includes('bespoke')) {
              urlParams.set('bespoke-size', encodeURIComponent(selectionTitle));
            } else {
              urlParams.delete('bespoke-size');
            }
            let updatedParams = urlParams.toString();
            window.history.replaceState({}, '', `${window.location.pathname}?${updatedParams}`);
            // Update CTA
            ctaState();
          }
        });
      });

    } // Ring Size dropdown

    // Initial discs
    if (customiseSection.classList.contains('customise-discs')) {
      // If MOV, update initials dropdown and panel button with selected number of discs
      if (customiseSection.getAttribute('data-multi-option-variant-section') == 'true') {
        customiseSection.querySelectorAll('.pill').forEach(function(pill){
          // Click pill
          pill.addEventListener('click', e => {
            // Get number of discs selected
            let numberOfDiscs = pill.getAttribute('data-number-of-discs');
            let customiseInitialsSection = document.querySelector('.customise-initials');
            customiseInitialsSection.innerHTML = productCustomise.sections[getCustomiseSectionIndex(customiseInitialsSection)].default_innerHTML;
            customiseInitialsSection.classList.remove('complete');
            productCustomise.sections[getCustomiseSectionIndex(customiseInitialsSection)].complete = false;
            ctaState();
            //Apply placeholder discs on dropdown button
            let initialsDropdownBtn = customiseInitialsSection.querySelector('.customise-dropdown-btn');
            let buttonImageCopy = initialsDropdownBtn.querySelectorAll('.images span')[0];
            initialsDropdownBtn.querySelectorAll('.images span').forEach((image) => image.remove()); // Remove existing placeholder disc images
            for (let i = 0; i < numberOfDiscs; i++) {
              let buttonImageNew = buttonImageCopy.cloneNode(true);
              initialsDropdownBtn.querySelector('.images').append(buttonImageNew);
            }
            // Apply selection boxes
            let initialsDropdown = customiseInitialsSection.querySelector('.customise-dropdown');
            let initialsSelectionBoxCopy = initialsDropdown.querySelectorAll('.initials-selection span')[0];
            initialsDropdown.querySelectorAll('.initials-selection span').forEach((box) => box.remove()); // Remove existing selection boxes
            for (let i = 0; i < numberOfDiscs; i++) {
              let initialsSelectionBoxNew = initialsSelectionBoxCopy.cloneNode(true);
              initialsDropdown.querySelector('.initials-selection').append(initialsSelectionBoxNew);
            }
            initialsDropdown.querySelectorAll('.initials-selection span').forEach((box) => box.classList.remove('active'));
            initialsDropdown.querySelectorAll('.initials-selection span')[0].classList.add('active');
            // Re-register initials event listeners
            registerCustomiseEventListeners(customiseInitialsSection);
            // Update discs props
            // let propKey = customiseSection.getAttribute('data-customise-prop');
            // productCustomise.selection.props[propKey] = numberOfDiscs;
            // Update gallery images
            if (pill.hasAttribute('data-variant-image')) {
              let variantImageSrc = pill.getAttribute('data-variant-image');
              const gallery = document.getElementById('product-gallery');
              // Update main gallery image
              const gallerySlides = gallery.querySelectorAll('.slider .slick-slide');
              for (let i = 0; i < gallerySlides.length; i++) {
                let slide = gallerySlides[i];
                if(slide.querySelector('img[data-variable-image="true"]')) {
                  let newImageSrc;
                  if(slide.querySelector('img').src.includes('products/')) {
                    newImageSrc = slide.querySelector('img').src.split('products/')[0] + variantImageSrc;
                  } else if(slide.querySelector('img').src.includes('files/')) {
                    newImageSrc = slide.querySelector('img').src.split('files/')[0] + variantImageSrc;
                  }
                  slide.querySelector('img').setAttribute('src', newImageSrc);
                  slide.querySelector('source').setAttribute('srcset', newImageSrc);
                  // Slick Slider runs on jQuery:
                  let slideIndex = window.innerWidth <= desktopBreakPoint ? i-1 : i; // Account for cloned slide on mobile at index [0]
                  $('#product-gallery .slider').slick('slickGoTo', slideIndex); // Corresponding thumbnail changes after slide change
                  break;
                }
              }
              // Update gallery thumbnail
              let variableThumbnailImage = gallery.querySelectorAll('.gallery-thumbnails .gallery-thumbnail img[data-variable-image="true"]')[0];
              let newImageSrc;
              if(variableThumbnailImage.src.includes('products/')) {
                newImageSrc = variableThumbnailImage.src.split('products/')[0] + variantImageSrc;
              } else if(variableThumbnailImage.src.includes('files/')) {
                newImageSrc = variableThumbnailImage.src.split('files/')[0] + variantImageSrc;
              }
              variableThumbnailImage.setAttribute('src', newImageSrc);
            }
          });
        });
      }
      // Else auto apply discs props
      else {
        // let activePill = customiseSection.querySelector('.pill.active');
        // let propKey = customiseSection.getAttribute('data-customise-prop');
        // productCustomise.selection.props[propKey] = activePill.getAttribute('data-number-of-discs');
      }
    } // Initial discs

    // Initials
    if (customiseSection.classList.contains('customise-initials')) {

      //let customiseInitialsSection = document.querySelector('.customise-initials');
      let initialsDropdownBtn = customiseSection.querySelector('.customise-dropdown-btn');
      let initialsDropdown = customiseSection.querySelector('.customise-dropdown');
      //let initialsApplyBtn = initialsDropdown.querySelector('.dropdown-panel-footer .btn');
      let initialsOptions = initialsDropdown.querySelectorAll('.dropdown-panel .initials-options a');
      let initialsSelectionBoxes = initialsDropdown.querySelectorAll('.initials-selection span');
      let propKey = customiseSection.getAttribute('data-customise-prop');

      // Click selection box
      initialsSelectionBoxes.forEach(function(initialsSelectionBox){
        initialsSelectionBox.addEventListener('click', e => {
          // Switch active box
          initialsSelectionBoxes.forEach((box) => box.classList.remove('active'));
          initialsSelectionBox.classList.add('active');
          // Move pointer to next selection box
          let arrowPositionLeft = initialsSelectionBox.offsetLeft;
          initialsDropdown.querySelector('.initials-selection .pointer').style.left = `${arrowPositionLeft}px`;
          // Disable Apply button (Mobile only)
          //initialsApplyBtn.classList.add('disabled');
        });
      });

      // Select character
      initialsOptions.forEach(function(initialsOption){
        initialsOption.addEventListener('click', e => {
          let selectedCharacter = initialsOption.getAttribute('data-initial');
          let selectedCharacterClass = initialsOption.getAttribute('class');
          // Update selection box
          initialsDropdown.querySelector('.initials-selection span.active').setAttribute('class', `active ${selectedCharacterClass}`);
          initialsDropdown.querySelector('.initials-selection span.active').setAttribute('title', selectedCharacter);

          // If more initials to be selected
          if(initialsDropdown.querySelectorAll('.initials-selection .initial-blank-faded').length > 0) {
            let currentSelectionBox = initialsDropdown.querySelector('.initials-selection span.active');
            let nextSelectionBox;
            // If the next is blank, focus on this
            if(currentSelectionBox.nextElementSibling.classList.contains('initial-blank-faded')) {
              nextSelectionBox = currentSelectionBox.nextElementSibling;
            }
            // Else loop back, find the next blank, and focus
            else {
              let remainingSelectionBoxes = initialsDropdown.querySelectorAll('.initials-selection span.initial-blank-faded');
              nextSelectionBox = remainingSelectionBoxes[0];
            }
            // Switch active box
            currentSelectionBox.classList.remove('active');
            nextSelectionBox.classList.add('active');
            // Move pointer to next selection box
            let arrowPositionLeft = nextSelectionBox.offsetLeft;
            initialsDropdown.querySelector('.initials-selection .pointer').style.left = `${arrowPositionLeft}px`;
          }
          // Else if all selected
          else {
            // Enable Apply button (Mobile only)
            // initialsApplyBtn.classList.remove('disabled');
            // initialsApplyBtn.addEventListener('click', e => {
            //   initialsDropdown.classList.remove('active');
            //   handleFixedElements('show');
            // });
            // Close panel (Desktop only)
            //if( window.innerWidth > desktopBreakPoint ) {
              initialsDropdown.classList.remove('active');
              handleFixedElements('show');
            //}
            // Update dropdown button
            let selectionStr = '';
            let buttonImages = initialsDropdownBtn.querySelectorAll('.images span');
            initialsSelectionBoxes.forEach( function(box, i) {
              selectionStr += `${box.getAttribute('title')}, `;
              let initialClass = box.getAttribute('class').replace('active', '').replace(' ', '');
              buttonImages[i].setAttribute('class', initialClass);
            });
            selectionStr = selectionStr.replace(/,\s*$/, ""); // remove last comma
            buttonImages = initialsDropdownBtn.querySelector('.images').outerHTML;
            initialsDropdownBtn.innerHTML = `<span>${selectionStr}</span> <span>Edit</span> ${buttonImages}`;
            customiseSection.classList.add('complete');
            productCustomise.sections[getCustomiseSectionIndex(initialsOption)].complete = true;
            customiseSection.querySelector('.customise-prompt').style.display = 'none';
            if(productCustomise.selection.variant_id == '' || productCustomise.selection.variant_id == null) {
              productCustomise.selection.variant_id = productTop.getAttribute('data-selected-variant-id');
            }
            // Update props
            productCustomise.selection.props[propKey] = selectionStr;
            ctaState();

          }
        });
        // Zoom on hover (desktop only)
        const zoomBox = initialsDropdown.querySelector('.dropdown-panel-zoom-box');
        const zoomBoxLabel = zoomBox.querySelector('.label');
        initialsOption.addEventListener('mouseenter', e => {
          // Set image in zoom box
          let computedStyle = window.getComputedStyle(initialsOption);
          zoomBox.style.backgroundImage = computedStyle.getPropertyValue('background-image');
          // Set image in zoom label
          zoomBoxLabel.innerText = initialsOption.getAttribute('data-initial');
          // Align zoom box vertically
          let topRelativeToParent = initialsOption.getBoundingClientRect().top - initialsDropdown.getBoundingClientRect().top;
          zoomBox.style.top = `${topRelativeToParent - ((zoomBox.offsetHeight - initialsOption.offsetHeight) / 2)}px`;
          zoomBox.classList.add('active');
        });
        initialsOption.addEventListener('mouseleave', e => {
          zoomBox.classList.remove('active');
        });
      });

    } // Initials


    // Birthstones
    if (customiseSection.classList.contains('customise-birthstone')) {

      const customiseBirthstoneSection = document.querySelector('.customise-birthstone');
      const birthstoneDropdownBtn = customiseBirthstoneSection.querySelector('.customise-dropdown-btn');
      const birthstoneDropdownBtnDefault = birthstoneDropdownBtn.innerHTML;
      const birthstoneDropdown = customiseBirthstoneSection.querySelector('.customise-dropdown');
      const birthstoneOptions = birthstoneDropdown.querySelectorAll('.dropdown-panel .birthstone-options a');
      let propKey = customiseSection.getAttribute('data-customise-prop');
      // An add-on section is the same as a customise section, but is not a required field, and it adds a separate product on add-to-bag
      let addOn = customiseBirthstoneSection.classList.contains('add-on') ? true : false;

      // Select item
      birthstoneOptions.forEach(function(birthstoneOption){
        birthstoneOption.addEventListener('click', e => {
          // Close panel
          birthstoneDropdown.classList.remove('active');
          // Reset section if "No Birthstone" is selected
          if(birthstoneOption.parentNode.classList.contains('no-birthstone')) {
            birthstoneDropdownBtn.innerHTML = birthstoneDropdownBtnDefault;
            productCustomise.sections[getCustomiseSectionIndex(birthstoneOption)].add_on_variant_id = null;
            customiseBirthstoneSection.classList.remove('complete');
            productCustomise.sections[getCustomiseSectionIndex(birthstoneOption)].complete = false;
            setTimeout(() => {
              updateShippingTime(birthstoneOption);
            },200); // Timeout delay for dropdown panel closing
            productCustomise.selection.availability_status = birthstoneOption.getAttribute('data-availability');
            // Check if eligible for Collect in Store
            collectInStoreNoticeDisplay(birthstoneOption.getAttribute('data-availability'));
            ctaState();
          }
          // Else apply selection
          else {
            // Update dropdown button
            let selectionTitle = birthstoneOption.innerHTML.includes('</span>') ? birthstoneOption.innerHTML.split('</span>')[1].trim() : birthstoneOption.innerText.replace('\n', ' '); // Remove month if exists
            let selectionImage = birthstoneOption.querySelector('img').outerHTML;
            if(addOn) {
              let addOnPrice = birthstoneDropdownBtn.querySelectorAll('span')[1].innerText;
              birthstoneDropdownBtn.innerHTML = `<span>${selectionTitle}</span> <span>${addOnPrice}</span> <div class="images">${selectionImage}</div>`;
            } else {
              birthstoneDropdownBtn.innerHTML = `<span>${selectionTitle}</span> <div class="images">${selectionImage}</div>`;
            }
            // Mark section complete
            customiseBirthstoneSection.classList.add('complete');
            productCustomise.sections[getCustomiseSectionIndex(birthstoneOption)].complete = true;
            customiseBirthstoneSection.querySelector('.customise-prompt').style.display = 'none';
            // Update props
            // productCustomise.selection.props[propKey] = selectionTitle;
            // Check for MOV (only if not add-on)
            if (multiOptionVariants && addOn == false) {
              multiOptionVariantsApply(birthstoneOption);
            }
            else {
              let variantId = birthstoneOption.getAttribute('data-variant-id');
              if(addOn) {
                productCustomise.sections[getCustomiseSectionIndex(birthstoneOption)].add_on_variant_id = variantId;
              } else {
                productCustomise.selection.variant_id = variantId;
                // Push variant ID of selected to URL parameter
                changeUrlVariantId(variantId);
              }
              // Shipping time
              setTimeout(() => {
                // For add-ons, only update shipping time if the product is available by default
                if(addOn) {
                  if(defaultProductAvailability !== 'out-of-stock') {
                    updateShippingTime(birthstoneOption);
                  }
                } else {
                  updateShippingTime(birthstoneOption);
                }
              },200); // Timeout delay for dropdown panel closing
              // Availability state
              if(!addOn) { //  Don't apply for add-ons
                productCustomise.selection.availability_status = birthstoneOption.getAttribute('data-availability');
                // Check if eligible for Collect in Store
                collectInStoreNoticeDisplay(birthstoneOption.getAttribute('data-availability'));
              }
            }
            // Change gallery image (if variant has image)
            let variantImage = birthstoneOption.getAttribute('data-variant-image');
            if (variantImage) {
              if(variantImage.includes('products/')) {
                variantImage = variantImage.split('products/')[1].split('.jpg')[0];
              } else if(variantImage.includes('files/')) {
                variantImage = variantImage.split('files/')[1].split('.jpg')[0];
              }
              const gallery = document.getElementById('product-gallery');
              const gallerySlides = gallery.querySelectorAll('.slider .slick-slide');
              gallerySlides.forEach( function(slide, i) {
                if( window.innerWidth <= desktopBreakPoint ) { // Mobile only
                  i = i-1; // Account for cloned slide on mobile at index [0]
                }
                if(slide.querySelector('img')) {
                  let imgSrc = slide.querySelector('img').getAttribute('src');
                  if(imgSrc.includes(variantImage)) {
                    // Slick Slider runs on jQuery:
                    $('#product-gallery .slider').slick('slickGoTo', i); // Corresponding thumbnail changes after slide change
                    return false;
                  }
                }
              })
            }
            ctaState();
          }

        });
      });

    } // Birthstones


    // Starsign/Zodiac
    if (customiseSection.classList.contains('customise-starsign-zodiac')) {

      const customiseStarsignZodiacSection = document.querySelector('.customise-starsign-zodiac');
      const starsignZodiacDropdownBtn = customiseStarsignZodiacSection.querySelector('.customise-dropdown-btn');
      const starsignZodiacDropdown = customiseStarsignZodiacSection.querySelector('.customise-dropdown');
      const starsignZodiacOptions = starsignZodiacDropdown.querySelectorAll('.dropdown-panel .starsign-zodiac-options a');
      let propKey = customiseSection.getAttribute('data-customise-prop');

      // Select item
      starsignZodiacOptions.forEach(function(starsignZodiacOption){
        starsignZodiacOption.addEventListener('click', e => {
          // Close panel
          starsignZodiacDropdown.classList.remove('active');
          // Update dropdown button
          let selectionTitle = starsignZodiacOption.innerText.replace('\n', ' ');
          let selectionImage = starsignZodiacOption.querySelector('img').outerHTML;
          starsignZodiacDropdownBtn.innerHTML = `<span>${selectionTitle}</span> <div class="images">${selectionImage}</div>`;
          // Mark section complete
          customiseStarsignZodiacSection.classList.add('complete');
          productCustomise.sections[getCustomiseSectionIndex(starsignZodiacOption)].complete = true;
          customiseStarsignZodiacSection.querySelector('.customise-prompt').style.display = 'none';
          // Update props
          // productCustomise.selection.props[propKey] = selectionTitle;
          // Check for MOV
          if (multiOptionVariants) {
            multiOptionVariantsApply(starsignZodiacOption);
          }
          else {
            let variantId = starsignZodiacOption.getAttribute('data-variant-id');
            productCustomise.selection.variant_id = variantId;
            // Push variant ID of selected to URL parameter
            changeUrlVariantId(variantId);
            // Shipping time
            setTimeout(() => {
              updateShippingTime(starsignZodiacOption);
            },200); // Timeout delay for dropdown panel closing
            // Availability state
            productCustomise.selection.availability_status = starsignZodiacOption.getAttribute('data-availability');
            // Check if eligible for Collect in Store
            collectInStoreNoticeDisplay(starsignZodiacOption.getAttribute('data-availability'));
          }
          // Change gallery image (if variant has image)
          let variantImage = starsignZodiacOption.getAttribute('data-variant-image');
          if (variantImage) {
            if(variantImage.includes('products/')) {
              variantImage = variantImage.split('products/')[1].split('.jpg')[0];
            } else if(variantImage.includes('files/')) {
              variantImage = variantImage.split('files/')[1].split('.jpg')[0];
            }
            const gallery = document.getElementById('product-gallery');
            const gallerySlides = gallery.querySelectorAll('.slider .slick-slide');
            gallerySlides.forEach( function(slide, i) {
              if( window.innerWidth <= desktopBreakPoint ) { // Mobile only
                i = i-1; // Account for cloned slide on mobile at index [0]
              }
              if(slide.querySelector('img')) {
                let imgSrc = slide.querySelector('img').getAttribute('src');
                if(imgSrc.includes(variantImage)) {
                  // Slick Slider runs on jQuery:
                  $('#product-gallery .slider').slick('slickGoTo', i); // Corresponding thumbnail changes after slide change
                  return false;
                }
              }
            })
          }
          ctaState();

        });
      });

    } // Starsign/Zodiac


    // Variant Price (vouchers)
    if (customiseSection.classList.contains('customise-variant-price')) {

      const customiseVariantPriceSection = document.querySelector('.customise-variant-price');
      const variantPriceDropdownBtn = customiseVariantPriceSection.querySelector('.customise-dropdown-btn');
      const variantPriceDropdown = customiseVariantPriceSection.querySelector('.customise-dropdown');
      const variantPriceOptions = variantPriceDropdown.querySelectorAll('.dropdown-panel .variant-price-options a');
      let propKey = customiseSection.getAttribute('data-customise-prop');

      // Select item
      variantPriceOptions.forEach(function(variantPriceOption){
        variantPriceOption.addEventListener('click', e => {
          // Close panel
          variantPriceDropdown.classList.remove('active');
          // Update dropdown button
          let selectionTitle = variantPriceOption.innerText.replace('\n', ' ');
          let variantId = variantPriceOption.getAttribute('data-variant-id');
          variantPriceDropdownBtn.innerHTML = `<span>${selectionTitle}</span>`;
          // Mark section complete
          customiseVariantPriceSection.classList.add('complete');
          productCustomise.sections[getCustomiseSectionIndex(variantPriceOption)].complete = true;
          customiseVariantPriceSection.querySelector('.customise-prompt').style.display = 'none';
          productCustomise.selection.variant_id = variantId;
          // Update shipping time
          productCustomise.selection.shipping_time = variantPriceOption.getAttribute('data-shipping-time');
          // Update props
          productCustomise.selection.props[propKey] = selectionTitle;
          // Push variant ID of selected to URL parameter
          changeUrlVariantId(variantId);
          ctaState();
        });
      });

    } // Variant Price


    /*
    // Notebook
    if (customiseSection.classList.contains('customise-notebook')) {

      const customiseNotebookSection = document.querySelector('.customise-notebook');
      const notebookDropdownBtn = customiseNotebookSection.querySelector('.customise-dropdown-btn');
      const notebookDropdown = customiseNotebookSection.querySelector('.customise-dropdown');
      const notebookOptions = notebookDropdown.querySelectorAll('.dropdown-panel .notebook-options a');
      let propKey = customiseSection.getAttribute('data-customise-prop');

      // Select item
      notebookOptions.forEach(function(notebookOption){
        notebookOption.addEventListener('click', e => {
          // Close panel
          notebookDropdown.classList.remove('active');
          // Update dropdown button
          let selectionTitle = notebookOption.innerText.replace('\n', ' ');
          notebookDropdownBtn.innerHTML = `<span>${selectionTitle}</span>`;
          // Mark section complete
          customiseNotebookSection.classList.add('complete');
          productCustomise.sections[getCustomiseSectionIndex(notebookOption)].complete = true;
          customiseNotebookSection.querySelector('.customise-prompt').style.display = 'none';
          // Update props
          // productCustomise.selection.props[propKey] = selectionTitle;
          ctaState();
        });
      });

    } // Notebook
    */


    /*
    // Coordinates
    if (customiseSection.classList.contains("customise-coordinates")) {

      // Coordinates page
      const coordinatesDropdownBtn = customiseSection.querySelector('.customise-dropdown-btn');
      //const coordinatesDropdown = customiseSection.querySelector('.customise-dropdown');
      const coordinatesOverlay = document.getElementById('coordinates-overlay');
      let addEditCoordinates = coordinatesDropdownBtn.querySelector(".add-edit-coordinates");
      let finalCoordinates = coordinatesDropdownBtn.querySelector(".final-coordinates");
      // Props
      let propKey = customiseSection.getAttribute("data-customise-prop");
      // Form
      let coordinatesForm = document.getElementById("coordinates-form");
      let formGuideBtn = document.getElementById("form-guide-btn");
      let formInputs = coordinatesForm.querySelectorAll("input, select");
      let errorMessage = coordinatesForm.querySelector(".error-message");
      let confirmCoordinates = coordinatesForm.querySelector(".confirm-coordinates");
      let previewCoordinates = coordinatesForm.querySelector(".preview-coordinates");
      // inputValidationCheck
      let longDegreesInput = document.getElementById("long-degree");
      let longMinutesInput = document.getElementById("long-minute");
      let longSecondsInput = document.getElementById("long-second");
      let longitudeDegrees180 = false;
      let latitudeDegree90 = false;
      let allInputsValid = false;
      let intCheck = /^[0-9]+$/;
      // Coordinate characters
      const symbolDegrees = '°';
      const symbolMinutes = '′';
      const symbolSeconds = '″';


      function longitudeTotalSize() { // returns total number of digits in all longitude inputs combined
        let longitudeTotalSize = 0;
        [longDegreesInput, longMinutesInput, longSecondsInput].forEach(input => {
          longitudeTotalSize += input.value.toString().replaceAll(".", "").length; // remove decimals
        });
        return longitudeTotalSize;
      }


      function allInputsValidationCheck(displayErrorMessage) {
        for (let i = 0; i < formInputs.length; i++) {
          if(formInputs[i].getAttribute('data-valid') == 'false') {
            allInputsValid = false;
            confirmCoordinates.classList.remove("btn-solid");
            if(displayErrorMessage) {
              inputValidationCheck(formInputs[i], true); // true = validate inputs that are empty
            }
            break;
          } else if (i == formInputs.length - 1) { // If last input
            // All inputs are valid
            allInputsValid = true;
            confirmCoordinates.classList.add("btn-solid");
          }
        }
      }


      function inputValidationApply(element, valid, message) {
        // Remove all visual errors
        formInputs.forEach(formInput => {
          formInput.classList.remove("invalid");
        });
        errorMessage.style.display = "none";
        if(valid == true) {
          element.setAttribute('data-valid', true);
        } else {
          // Display error for current input only
          errorMessage.innerHTML = message;
          errorMessage.style.display = "block";
          element.classList.add("invalid");
          element.setAttribute('data-valid', false);
        }
      }


      function updateCoordinatesPreview(element) {
        let elementId = element.getAttribute('id');
        // Get the element by the exact data attribute value
        let previewPart = previewCoordinates.querySelector(`span[data-matching-input-id="${elementId}"]`);
        if (element.value.length == 0) {
          // Revert to default preview text
          previewPart.innerHTML = previewPart.getAttribute('data-default-value');
          previewPart.classList.remove('complete');
        } else {
          // Update preview text with value
          previewPart.innerHTML = element.value;
          previewPart.classList.add('complete');
        }
        // Append symbol to preview part
        if(element.classList.contains('degrees-input')) {
          previewPart.innerHTML += symbolDegrees;
        } else if(element.classList.contains('minutes-input')) {
          previewPart.innerHTML += symbolMinutes;
        } else if(element.classList.contains('seconds-input')) {
          previewPart.innerHTML += symbolSeconds;
        }
      }


      // Check if input is valid or not valid
      function inputValidationCheck (element, validateEmptyInput) {

        // If Select element
        if (element.tagName.toLowerCase() === "select") {
          if (element.value == "") {
            inputValidationApply(element, false, "Please select an option from the dropdown.");
          } else {
            updateCoordinatesPreview(element);
            inputValidationApply(element, true);
          }


        // If Input element
        } else if (element.tagName.toLowerCase() === "input") {

          // Notes:
          // - Number input allows characters [0-9, ., +, -, e, E]
          // - Cannot read e/E from input value
          // - If user enters e/E input will neither be valid or invalid but will need to be completed

          // If input is empty
          if (element.value.length == 0) {
            if(validateEmptyInput) {
              inputValidationApply(element, false, "Please enter a number.");
            } else {
              element.setAttribute('data-valid', false);
              element.classList.remove("invalid");
              errorMessage.style.display = "none";
            }
            updateCoordinatesPreview(element);
          }
          // If first digit is 0 followed by a different number (e.g. "05")
          else if (element.value.length > 1 && element.value.toString().charAt(0) == "0" && element.value.toString().charAt(1).match(/[1-9]/)) {
            inputValidationApply(element, false, "Coordinate cannot start with zero.");
          }
          // If degrees
          else if (element.classList.contains("degrees-input")) {

            if (element.value.includes("-")) { // Check for minus
              inputValidationApply(element, false, "Please select a cardinal direction instead of using minus.");
            } else if (!element.value.match(intCheck)) { // No decimals
              inputValidationApply(element, false, "Degrees can only contain whole numbers.");

            // If latitude degrees
            } else if (element.classList.contains("latitude")) {
              if (element.value > 90) { // Check max Lat degrees
                inputValidationApply(element, false, "Please enter a number between 0 and 90.");
              } else { // Valid
                element.value == 90 ? latitudeDegree90 = true : latitudeDegree90 = false;
                updateCoordinatesPreview(element);
                inputValidationApply(element, true);
              }

            // If longitude degrees
            } else if (element.classList.contains("longitude")) {
              if (element.value > 180 ) { // Check max Long degrees
                inputValidationApply(element, false, "Please enter a number between 0 and 180.");
              } else if (longitudeTotalSize() > 7) { // Check max total Long digits
                inputValidationApply(longSecondsInput, false, `7 numbers maximum for longitude. Please use a whole number for seconds (${symbolSeconds})`);
              } else { // Valid
                element.value == 180 ? longitudeDegrees180 = true : longitudeDegrees180 = false;
                updateCoordinatesPreview(element);
                inputValidationApply(element, true);
              }
            }

          // If Minutes
          } else if (element.classList.contains("minutes-input")) {

            if (element.classList.contains("latitude") && latitudeDegree90 == true && element.value > 0) { // Check max Lat degrees
              inputValidationApply(element, false, `Latitude cannot be greater than 90${symbolDegrees}`);
            } else if (element.classList.contains("longitude") && longitudeDegrees180 == true && element.value > 0) { // Check max Long degrees
              inputValidationApply(element, false, `Longitude cannot be greater than 180${symbolDegrees}.`);
            } else if (element.value >= 60) { // Check max value
              inputValidationApply(element, false, "Please enter a number between 0 and 59.");
            } else if (!element.value.match(intCheck)) { // No decimals
              inputValidationApply(element, false, `Minutes (${symbolMinutes}) can only contain whole numbers.`);
            } else if (element.classList.contains("longitude") && longitudeTotalSize() > 7) { // Check max total Long digits
              inputValidationApply(longSecondsInput, false, `7 numbers maximum for longitude. Please use a whole number for seconds (${symbolSeconds})`);
            } else { // Valid
              updateCoordinatesPreview(element);
              inputValidationApply(element, true);
            }
          // If Seconds
          } else if (element.classList.contains("seconds-input")) {

            // Track amount of numbers after decimal
            let numbersAfterDecimal = 0;
            if (element.value.toString().includes('.')) {
              numbersAfterDecimal = element.value.toString().split('.')[1].length;
            }

            if (element.classList.contains("latitude") && latitudeDegree90 == true && element.value > 0) { // Check max Lat degrees
              inputValidationApply(element, false, `Latitude cannot be greater than 90${symbolDegrees}`);
            } else if (element.classList.contains("longitude") && longitudeDegrees180 == true && element.value > 0) { // Check max Long degrees
              inputValidationApply(element, false, `Longitude cannot be greater than 180${symbolDegrees}.`);
            } else if (element.value >= 60) { // Check max value
              inputValidationApply(element, false, "Please enter a number between 0 and 59.");
            } else if (numbersAfterDecimal > 1) { // Check seconds decimal
              inputValidationApply(element, false, `Please shorten seconds (${symbolSeconds}) to within one decimal place`);
            } else if (element.classList.contains("longitude") && longitudeTotalSize() > 7) { // Check max total Long digits
              inputValidationApply(longSecondsInput, false, `7 numbers maximum for longitude. Please use a whole number for seconds (${symbolSeconds})`);
            } else { // Valid
              updateCoordinatesPreview(element);
              inputValidationApply(element, true);
            }

          }
        }

        // Run validation check on all inputs
        allInputsValidationCheck(false); // false = do not display Error Message

      } // end. inputValidationCheck


      // Click, paste, keyup, change event listeners for each form input/select
      for (let i = 0; i < formInputs.length; i++) {
        //formInputs[i].addEventListener('click', function(){ inputValidationCheck(formInputs[i]); }, false);
        formInputs[i].addEventListener('paste', function(){ inputValidationCheck(formInputs[i]); }, false);
        formInputs[i].addEventListener('keyup', function(){ inputValidationCheck(formInputs[i]); }, false);
        formInputs[i].addEventListener('change', function(){ inputValidationCheck(formInputs[i]); }, false);
      }


      // Confirm coordinates button
      confirmCoordinates.addEventListener("click", function(e){
        if(allInputsValid == true) {
          // Get final coordinates string
          let finalCoordinatesString = '';
          let previewCoordinatesParts = previewCoordinates.querySelectorAll('span');
          previewCoordinatesParts.forEach(part => {
            finalCoordinatesString += part.innerText + ' '; // append coordinate part text plus space
          });
          finalCoordinatesString = finalCoordinatesString.replace(/\s*$/,""); // remove trailing space

          // Close overlay
          coordinatesOverlay.classList.remove('active');
          // Update dropdown button
          finalCoordinates.innerText = finalCoordinatesString;
          addEditCoordinates.innerText = 'Edit coordinates';
          // Mark section complete
          customiseSection.classList.add('complete');
          productCustomise.sections[getCustomiseSectionIndex(coordinatesDropdownBtn)].complete = true;
          customiseSection.querySelector('.customise-prompt').style.display = 'none';
          // Update props
          productCustomise.selection.props[propKey] = finalCoordinatesString;
          ctaState();
        }
        else {
          allInputsValidationCheck(true); // true = display Error Message
        }
      });

      formGuideBtn.addEventListener("click", function() {
        coordinatesOverlay.classList.remove("active");
      })


    } // end coordinates
    */


    // Engraving
    if (customiseSection.classList.contains('customise-engraving')) {

      const engravingCustomiseBtn = customiseSection.querySelector('.customise-dropdown-btn');
      const engravingOverlay = document.getElementById('engraving-overlay');
      const engravingPreview = document.getElementById('engraving-preview');
      const engravingStyle = engravingPreview.getAttribute('data-engraving-style');
      const engravingPreviewBoundary = engravingPreview.querySelector('.engraveable-area');
      const engravingPreviewChars = engravingPreview.querySelector('.engraving-container');
      const engravingForm = document.getElementById('engraving-form');
      const engravingInput = document.getElementById('engraving-input');
      const engravingErrorMsg = engravingForm.querySelector('.error-message');
      const engravingSubmit = engravingForm.querySelector('.confirm-engraving');
      let propKey = customiseSection.getAttribute('data-customise-prop');


      const updateEngravingPreview = (str) => {
        // Reset content
        engravingPreviewChars.innerHTML = '';
        // Append chars
        if(str.length) {
          // Signet engraving style (split chars into <span> for separate styling)
          if(engravingStyle.includes('signet')) {
            for (const char of str) {
              const span = document.createElement('span');
              span.textContent = char; // Set the character as span content
              span.setAttribute('data-char', char);
              engravingPreviewChars.appendChild(span);
            }
          }
          // Stacking engraving style
          else if(engravingStyle.includes('stacking')) {
            engravingPreviewChars.innerText = str;
          }
          // Adjust (scale) to fit within boundary
          let boundaryWidth = engravingPreviewBoundary.clientWidth;
          let charsWidth = engravingPreviewChars.clientWidth;
          if(charsWidth > boundaryWidth) {
            engravingPreviewChars.style.transform = `translate(-50%, -50%) scale(${boundaryWidth / charsWidth})`;
          } else {
            engravingPreviewChars.style.transform = `translate(-50%, -50%) scale(1)`;
          }
        }
        else {
          // Force hardware acceleration to repaint and avoid glyphs becoming stuck
          engravingPreviewChars.style.transform = `translateZ(0)`;
        }
        // Set data attribute
        engravingPreviewChars.setAttribute('data-char-count', str.length);
      }

      const handleEngravingError = (valid, message) => {
        if(valid == true) {
          if(message && (message.includes('uppercase') || message.includes('lowercase'))) { // info
            engravingErrorMsg.innerText = message;
            engravingErrorMsg.style.display = 'block';
            engravingErrorMsg.classList.add('info');
          } else { // No error/info
            engravingInput.classList.remove('invalid');
            engravingErrorMsg.classList.remove('info');
            engravingErrorMsg.innerText = '';
            engravingErrorMsg.style.display = 'none';
          }
        } else { // error
          engravingErrorMsg.innerText = message;
          engravingErrorMsg.style.display = 'block';
          engravingErrorMsg.classList.remove('info');
          engravingInput.classList.add('invalid');
        }
      }

      // Check if input is valid or not valid
      const inputValidationCheck = (displayErrorMessage) => {

        // Clear error message
        handleEngravingError(true);

        // Signet engraving style
        if(engravingStyle.includes('signet')) {

          const validChars = /^[A-ZÁÉÍÓÚ0-9\-\/\.,:;"'!@#$%&()]*$/;
          const lowercaseChars = /[a-z]/;
          // Input empty
          if (engravingInput.value.length == 0) {
            if(displayErrorMessage) {
              handleEngravingError(false, 'Please enter between 1 and 3 characters');
            }
            updateEngravingPreview(engravingInput.value);
          }
          // Check max chars
          else if (engravingInput.value.length > 3) {
            handleEngravingError(false, 'Max 3 characters');
          }
          // Check valid characters
          else if (!validChars.test(engravingInput.value.toUpperCase())) {
            handleEngravingError(false, `Valid characters include A-Z, [ÁÉÍÓÚ], 0-9, [.,:;"'!@#$%&()]*$]`);
          }
          // Check lowercase chars
          else if (lowercaseChars.test(engravingInput.value)) {
            handleEngravingError(true, 'All alphabetical characters will be uppercase');
            updateEngravingPreview(engravingInput.value.toUpperCase());
            return true;
          }
          // Input valid
          else {
            handleEngravingError(true);
            updateEngravingPreview(engravingInput.value);
            return true;
          }
          return;

        }

        // Stacking engraving style
        else if(engravingStyle.includes('stacking')) {

          const validChars = /^[a-záéíóú0-9\-\/\.,:;"'!@#$%&() ]*$/;
          const uppercaseChars = /[A-Z]/;
          // Input empty
          if (engravingInput.value.length == 0) {
            if(displayErrorMessage) {
              handleEngravingError(false, 'Please enter between 1 and 3 characters');
            }
            updateEngravingPreview(engravingInput.value);
          }
          // Check max chars
          else if (engravingInput.value.length > 9) {
            handleEngravingError(false, 'Max 9 characters');
          }
          // Check valid characters
          else if (!validChars.test(engravingInput.value.toLowerCase())) {
            handleEngravingError(false, `Valid characters include a-z, [áéíóú], 0-9, [.,:;"'!@#$%&()]*$]`);
          }
          // Check uppercase chars
          else if (uppercaseChars.test(engravingInput.value)) {
            handleEngravingError(true, 'All alphabetical characters will be lowercase');
            updateEngravingPreview(engravingInput.value.toLowerCase());
            return true;
          }
          // Input valid
          else {
            handleEngravingError(true);
            updateEngravingPreview(engravingInput.value);
            return true;
          }
          return;

        }

      } // inputValidationCheck

      // Paste, keyup, change event listeners for input
      engravingInput.addEventListener('paste', function(){ inputValidationCheck(); }, false);
      engravingInput.addEventListener('keyup', function(){ inputValidationCheck(); }, false);
      engravingInput.addEventListener('change', function(){ inputValidationCheck(); }, false);

      // Confirm engraving button
      engravingSubmit.addEventListener("click", function(e){
        e.preventDefault();
        if(inputValidationCheck() === true) {
          // Close overlay
          engravingOverlay.classList.remove('active');
          // Update customise button
          let engravingString = engravingInput.value.toUpperCase();
          engravingCustomiseBtn.innerHTML = `<span>${engravingString}</span><span>Edit engraving</span>`;
          // // Mark section complete
          customiseSection.classList.add('complete');
          productCustomise.sections[getCustomiseSectionIndex(engravingOverlay)].complete = true;
          customiseSection.querySelector('.customise-prompt').style.display = 'none';
          // Update props
          productCustomise.selection.props[propKey] = engravingString;
          ctaState();
        }
        else {
          inputValidationCheck(true); // true = display Error Message
        }
      });

    } // Engraving


    // Stone Count
    if (customiseSection.classList.contains('customise-stone-count')) {

      const customiseStoneCountSection = document.querySelector('.customise-stone-count');
      const stoneCountDropdownBtn = customiseStoneCountSection.querySelector('.customise-dropdown-btn');
      const stoneCountDropdown = customiseStoneCountSection.querySelector('.customise-dropdown');
      const stoneCountOptions = stoneCountDropdown.querySelectorAll('.dropdown-panel .stone-count-options a');
      let propKey = customiseSection.getAttribute('data-customise-prop');

      // Select item
      stoneCountOptions.forEach(function(stoneCountOption){
        stoneCountOption.addEventListener('click', e => {
          let variantId = stoneCountOption.getAttribute('data-variant-id');
          // Close panel
          stoneCountDropdown.classList.remove('active');
          // Update dropdown button
          let selectionTitle = getDirectInnerTextOnly(stoneCountOption);
          let priceAdditional;
          if(stoneCountOption.querySelector('.price-additional')) {
            priceAdditional = stoneCountOption.querySelector('.price-additional').innerText;
          }
          let buttonTexts = stoneCountDropdownBtn.querySelectorAll('span');
          buttonTexts[0].innerText = selectionTitle;
          buttonTexts[1].innerText = priceAdditional;
          buttonTexts[1].style.display = 'block';
          // Update product price
          const productPrice = document.getElementById('product-price');
          const productCompareAtPrice = document.getElementById('product-compare-at-price');
          const priceBlock = document.getElementById('price-and-metal');
          if (stoneCountOption.getAttribute('data-price') && productPrice.innerText !== stoneCountOption.getAttribute('data-price')) {
            productPrice.innerText = stoneCountOption.getAttribute('data-price');
          }
          if (stoneCountOption.getAttribute('data-compare-at-price')) {
            // Set compare-at-price and show it
            productCompareAtPrice.innerText = stoneCountOption.getAttribute('data-compare-at-price');
            priceBlock.classList.add('has-compare-at-price');
            productCompareAtPrice.style.display = 'block';
          } else {
            // Hide compare-at-price
            priceBlock.classList.remove('has-compare-at-price');
            productCompareAtPrice.style.display = 'none';
          }
          // Mark section complete
          customiseStoneCountSection.classList.add('complete');
          productCustomise.sections[getCustomiseSectionIndex(stoneCountOption)].complete = true;
          customiseStoneCountSection.querySelector('.customise-prompt').style.display = 'none';
          // Update props
          // productCustomise.selection.props[propKey] = selectionTitle;
          if (multiOptionVariants) {
            multiOptionVariantsApply(stoneCountOption);
          } else {
            productCustomise.selection.variant_id = variantId;
            // Update shipping time
            updateShippingTime(stoneCountOption);
            // Push variant ID of selected to URL parameter
            changeUrlVariantId(variantId);
          }
          ctaState();
        });
      });

    } // Stone Count

  } // registerCustomiseEventListeners()




  // Apply URL variant
  const applyUrlVariant = (urlVariantId, urlBespokeSize) => {
    if (multiOptionVariants) {
      let variant = productJSON.variants.find(v => v.id == urlVariantId);
      variant.option_values.forEach((value, i) => {
        let preSelectedOption = productTop.querySelector(`[data-variant-option-value="${value}"]`);
        if(preSelectedOption) {
          if(!preSelectedOption.classList.contains('active')) { // Only if option is not already active
            preSelectedOption.click(); // Simulate selection on this option
          }
        }
      });
    }
    else {
      let preSelectedOption = productTop.querySelector(`[data-variant-id="${urlVariantId}"]`);
      // If URL has bespoke-size param, decode and look for option with this size as innerText
      if(urlBespokeSize) {
        let urlBespokeSizeDecoded = decodeURIComponent(urlBespokeSize);
        let bespokeSizeOptions = productTop.querySelectorAll(`[data-variant-id="${urlVariantId}"]`);
        bespokeSizeOptions.forEach((option) => {
          // Check options' innerText for match against bespoke UK size (unique substring)
          if(option.innerText.includes(urlBespokeSizeDecoded.split('/')[1].trim())) {
            preSelectedOption = option;
          }
        });
      }
      if(preSelectedOption) {
        if(!preSelectedOption.classList.contains('active')) { // Only if option is not already active
          preSelectedOption.click(); // Simulate selection on this option
        }
      }
    }
  } // applyUrlVariant()




  // On page load
  customiseSections.forEach(function(customiseSection, i) {
    // Build productCustomise object section (from load state)
    buildCustomiseObjectSection(customiseSection, i);
    // Register event listeners for this section
    registerCustomiseEventListeners(customiseSection);
  });
  // Check for URL variant matching customise option
  if (urlVariantId) {
    applyUrlVariant(urlVariantId, urlBespokeSize);
  }
  // Apply state to CTA button
  ctaState();



} // if addToBagButton